var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardVoicemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156 128c-26,0 -46,22 -46,46 0,10 4,21 10,29l-37 0c16,-20 12,-49 -7,-64 -8,-7 -18,-11 -28,-11 -26,0 -47,19 -48,44 -1,26 18,47 44,48l113 0c26,1 47,-18 48,-44 1,-26 -19,-47 -44,-48l-5 0zm-108 76c-17,0 -30,-14 -30,-30 0,-14 11,-27 26,-28l3 0c16,1 28,15 26,31 0,14 -11,26 -25,27zm108 0c-16,0 -29,-13 -29,-30 0,-16 13,-29 29,-29 17,0 29,13 29,29 0,0 0,0 0,0l0 0c0,17 -12,30 -29,30l0 0z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "257,235 271,220 320,270 271,320 257,305 282,280 190,280 190,260 282,260 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardVoicemail);
export default __webpack_public_path__ + "static/media/forward-voicemail.51445bf9.svg";
export { ForwardRef as ReactComponent };